import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 184800 175767"
    {...props}
  >
    <path
      d="M111607 70726 92402 11619 73195 70726H11045l50280 36533-19205 59107 50282-36531 50280 36531-19207-59107 50280-36533z"
      style={{
        fill: "none",
        stroke: "#000",
        strokeWidth: 7178.36,
      }}
      className="stroke1"

    />
  </svg>
)
export default SvgComponent
